<template>
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="500" persistent>
        <v-card>
          <v-card-title class="text-h5 blue darken-3 white--text">
            Aprobar cositas
          </v-card-title>
  
          <v-card-text> 
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" outlined @click="enviar()"> Aceptar </v-btn>
            <v-btn color="red" outlined @click="cerrar()"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>
  
<script>

export default {
    data() {
        return { 
            dialog: false, 
        };
    },
    methods: {
        async openmodal() {
        //   this.dialog = true; 
        }, 

        cerrar(){ 
          this.dialog = false;
        },
        enviar(){  
        }
    }
};
</script>
  